import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChange } from '@angular/core';
import { JuvenileCase } from './../../../juvenile/juvenile-case';
import { PartyAttorney } from '../../../juvenile/juvenile-case-sections/party-attorney';
import { Juvenile } from '../../../juvenile/juvenile-case-sections/juvenile';

@Component({
  selector: 'app-parties-details',
  templateUrl: './parties-details.component.html',
  styleUrls: ['./../juvenile-case-view.component.less']
})
export class PartiesDetailsComponent {

@Input() juvenileCase: JuvenileCase;
juvenileMap: Map<string, PartyAttorney[]> = new Map();
partyAttorneysArr: any[] = [];
partyAttorneys: PartyAttorney[] = [];
partyList: Juvenile[] ;

  constructor() { }

  ngOnChanges(changes: { [propName: string]: SimpleChange}) {
    if (this.juvenileCase &&
      this.juvenileCase.getPartyList()) {
      this.partyList = this.juvenileCase.getPartyList();
      Object.keys(this.partyList).forEach(key =>  {
        let juvenile: Juvenile = this.partyList[key];
        let attorneyList:PartyAttorney[] = juvenile.getPartyAttorneyList();
        this.partyAttorneysArr.push(attorneyList);                
      });
     
    }
  }

  getAttorneyList(index : number) : PartyAttorney[] {
    
    let count: number = 0;
    for(const alias of this.partyAttorneysArr) {      
      this.partyAttorneys = alias;
      if(count === index) { return this.partyAttorneys; }
      count = count + 1;
    }  
   return null;
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/parties-details/parties-details.component.ts